import { type CSSProperties, type FunctionComponent, useMemo } from 'react'
import { useSignal, useSignalEffect } from '@/react/core/reactive.ts'
import {
  blockMutateOrderButton, hasPaidSeatOrder,
  onBack,
  order0,
  paymentContext0,
  scopeOrder0
} from '@/react/PaymentView/PaymentView.tsx'
import { LL0 } from '@/react/core/I18nService.tsx'
import PaymentScreenMoreOption from '@payment/PaymentScreenMoreOption.tsx'
import { makeRipple } from '@/react/core/ripple-utils.ts'
import { handlePrintInvoice, printInvoice } from '@/react/Printer/print-invoice.ts'
import { clsx } from "clsx";
import ButtonWrapper from "@/react/core/ButtonWrapper.tsx";
import { userFLow } from "@/shared/logger.ts";
import { loginUser } from "@/data/UserSignal.ts";

type PaymentRightPathTopNavType = {
  showReViewBill?: boolean;
  showCancel?: boolean;
  showAllDone?: boolean;
  showSplitViewBill?: boolean;
  showButtonIcon?: boolean;
  showButtonText?: boolean;

  /** Style props */
  paymentRightPathTopNavWidth?: CSSProperties["width"];
};

enum Type {
  Default = 'Default',
  Cancel = 'Cancel',
  Redivision = 'Redivision',
  AllDone = 'AllDone',
}

const PaymentRightPathTopNav: FunctionComponent<PaymentRightPathTopNavType> = (
  {
    showReViewBill = false,
    showCancel = false,
    showAllDone = false,
    showSplitViewBill = false,
    paymentRightPathTopNavWidth,
    showButtonIcon,
    showButtonText,
  }) => {
  const paymentRightPathTopNavStyle: CSSProperties = useMemo(() => {
    return {
      width: paymentRightPathTopNavWidth,
    };
  }, [paymentRightPathTopNavWidth]);

  const [type, setType] = useSignal<Type>(Type.Default);
  useSignalEffect(() => {
    if (!paymentContext0.splitEnable() && type() === Type.Cancel) {
      setType(Type.Redivision);
    }
  })

  // if (type() === Type.Default) showSplitViewBill = true;
  // if (type() === Type.Cancel) showCancel = true;
  if (type() === Type.Redivision) showReViewBill = true;
  if (type() === Type.AllDone) showAllDone = true;

  showSplitViewBill = !paymentContext0.splitEnable();
  showCancel = paymentContext0.splitEnable();

  return (
    <div
      className="z-[2] flex justify-center gap-[16px] text-left text-sm text-text-color-black-1e1e23 font-mulish h-[40px]"
      style={paymentRightPathTopNavStyle}
    >
      {showSplitViewBill && (
        <div
          className="!px-1 !py-0.5 w-full h-full self-stretch flex flex-row items-center justify-between py-0 px-2 z-[1] sm:pl-1 sm:pr-1 sm:box-border">
          <div
            className="flex-1 self-stretch flex flex-row items-center justify-start gap-3 text-center text-white-solid-white-100-ffffff">
            <PaymentScreenMoreOption />
            <ButtonWrapper onClick={() => {
              userFLow("click handlePrintInvoice in file PaymentRightOathTopNav", {
                username: loginUser()?.name,
                orderId: order0?.()._id
              })
              handlePrintInvoice(scopeOrder0())
            }} isDisabled={blockMutateOrderButton()}>
              <div
                className={clsx(
                  "rounded-81xl px-3 bg-orange-solid-orange-800-f25936 shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] h-[36px] overflow-hidden flex flex-row items-center justify-center py-0.5 box-border gap-[3px]",
                )}
                // ref={makeRipple}
                // onClick={async () => {
                //   await handlePrintInvoice(scopeOrder0());
                // }}
              >
                <img
                  className="relative w-[30px] h-[30px] object-cover sm:hidden Tablet_768:w-[26px] Tablet_768:h-[26px]"
                  alt=""
                  src="/payment-iconprinter-icon-3@2x.png"
                />
                <b
                  className="relative leading-[17px] sm:text-xs Tablet_768:text-xs Tablet_600:text-xs height_414:text-xs">
                  {LL0().fnBtn.paymentFunctions.bill()}
                </b>
              </div>
            </ButtonWrapper>
          </div>
          <div
            className={clsx(
              "self-stretch h-[36px] rounded-81xl bg-palette-blue-style shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] overflow-hidden flex flex-row items-center justify-center py-0.5 px-2.5 box-border gap-[3px] min-w-[60px]",
              {
                'opacity-70': blockMutateOrderButton() || hasPaidSeatOrder()
              }
            )}
            onClick={onBack}
            ref={makeRipple}
          >
            <img
              className="relative w-[30px] h-[30px] object-cover"
              alt=""
              src="/payment-iconback-icon@2x.png"
            />
            <b className="relative leading-[17px] hidden">{LL0().ui.back()}</b>
          </div>
        </div>
      )}
      {showCancel && (
        <>
          <div
            className="rounded-81xl [background:linear-gradient(180deg,_#ffda68,_#e3ac00)] shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] h-[36px] overflow-hidden shrink-0 flex flex-row items-center justify-center py-0.5 px-2.5 box-border gap-[3px] z-[0] text-center text-white-solid-white-100-ffffff"
            onClick={() => {
              userFLow("click onSplitCancel in file PaymentRightOathTopNav", {
                username: loginUser()?.name,
                orderId: order0?.()._id
              })
              paymentContext0.onSplitCancel()
            }}
          >
            <img
              className="relative w-[30px] h-[30px] object-cover hidden"
              alt=""
              src="/payment-ordervoucher-icon1@2x.png"
            />
            <b
              className="relative leading-[17px] sm:text-xs Tablet_768:text-xs Tablet_600:text-xs height_414:text-xs">{LL0().ui.cancel().toUpperCase()}</b>
          </div>
          <div
            className="min-w-[70px] rounded-81xl [background:linear-gradient(180deg,_#9DE345,_#3EA920)] shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] h-[36px] overflow-hidden shrink-0 flex flex-row items-center justify-center py-0.5 px-2.5 box-border gap-[3px] z-[0] text-center text-white-solid-white-100-ffffff"
            onClick={() => {
              userFLow("Split Bill Done in Payment", {
                username: loginUser()?.name,
                orderId: order0?.()._id
              })
              paymentContext0.moveRestItemsToSeat();
            }}
          >
            <b
              className="relative leading-[17px] sm:text-xs Tablet_768:text-xs Tablet_600:text-xs height_414:text-xs">
              {LL0().cashbook.done()}
            </b>
          </div>
        </>
        )}
    </div>
  );
};

export default PaymentRightPathTopNav;
